module.exports = __webpack_public_path__ + "img/scope_bg.69b3279.jpg";